import React, { useState } from 'react';
import { X, Download, Printer, QrCode } from 'lucide-react';
import inventoryService from '../services/inventoryService';
import toast from 'react-hot-toast';

const ProductLabelModal = ({ product, variant, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [qrData, setQrData] = useState(null);

  React.useEffect(() => {
    if (product?.id) {
      generateQRCode();
    }
  }, [product?.id]);

  const generateQRCode = async () => {
    setLoading(true);
    try {
      const response = await inventoryService.generateProductQRCode(product.id);
      if (response.success) {
        setQrData(response.data);
      }
    } catch (error) {
      toast.error('Erro ao gerar QR code');
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    const printContent = document.getElementById('printable-label');
    const WindowPrt = window.open('', '', 'width=400,height=600');
    WindowPrt.document.write(`
      <html>
        <head>
          <title>Etiqueta - ${product?.nome}</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; text-align: center; }
            .label { border: 2px solid #000; padding: 20px; width: 300px; margin: 0 auto; }
            .label h3 { margin: 0 0 10px 0; font-size: 16px; }
            .label p { margin: 5px 0; font-size: 12px; }
            .label img { width: 150px; height: 150px; }
            .label .sku { font-weight: bold; font-size: 14px; }
            .label .variant { font-size: 11px; color: #666; }
          </style>
        </head>
        <body>${printContent.innerHTML}</body>
      </html>
    `);
    WindowPrt.document.close();
    WindowPrt.focus();
    setTimeout(() => {
      WindowPrt.print();
      WindowPrt.close();
    }, 250);
  };

  const handleDownloadPNG = () => {
    if (qrData?.qr_code_image) {
      const link = document.createElement('a');
      link.download = `etiqueta-${product?.sku || product?.id}.png`;
      link.href = qrData.qr_code_image;
      link.click();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between p-4 border-b">
          <div className="flex items-center gap-2">
            <QrCode className="w-5 h-5 text-primary-600" />
            <h2 className="text-lg font-bold">Etiqueta do Produto</h2>
          </div>
          <button onClick={onClose} className="text-secondary-400 hover:text-secondary-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6" id="printable-label">
          {loading ? (
            <div className="text-center py-8">Gerando QR Code...</div>
          ) : qrData ? (
            <>
              <div className="text-center mb-4">
                <h3 className="text-xl font-bold text-secondary-900">{product?.nome}</h3>
                {variant && (
                  <p className="text-sm text-secondary-600">
                    {variant.cor && `Cor: ${variant.cor}`}
                    {variant.tamanho_label && ` | Tamanho: ${variant.tamanho_label}`}
                  </p>
                )}
                <p className="sku mt-1">SKU: {product?.sku}</p>
                {variant?.sku_variacao && (
                  <p className="variant">Variação: {variant.sku_variacao}</p>
                )}
                {variant?.barcode && (
                  <p className="text-xs mt-1">Barras: {variant.barcode}</p>
                )}
              </div>

              <div className="flex justify-center mb-4">
                <img
                  src={qrData.qr_code_image}
                  alt="QR Code"
                  className="w-48 h-48 border border-secondary-300 rounded-lg"
                />
              </div>

              <div className="text-center text-xs text-secondary-500 mb-4">
                <p>Escaneie para editar no sistema</p>
                <p className="font-mono mt-1">{qrData.qr_code}</p>
              </div>
            </>
          ) : (
            <div className="text-center py-8 text-secondary-500">
              Erro ao carregar dados
            </div>
          )}
        </div>

        <div className="flex justify-center gap-3 p-4 border-t bg-secondary-50">
          <button
            onClick={handleDownloadPNG}
            disabled={!qrData}
            className="flex items-center gap-2 px-4 py-2 bg-secondary-100 text-secondary-700 rounded-md hover:bg-secondary-200 disabled:opacity-50"
          >
            <Download className="w-4 h-4" />
            Baixar PNG
          </button>
          <button
            onClick={handlePrint}
            disabled={!qrData}
            className="flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 disabled:opacity-50"
          >
            <Printer className="w-4 h-4" />
            Imprimir
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductLabelModal;
